import { render, staticRenderFns } from "./ObjectsMap.vue?vue&type=template&id=479b05bd&scoped=true&"
import script from "./ObjectsMap.vue?vue&type=script&lang=js&"
export * from "./ObjectsMap.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsMap.vue?vue&type=style&index=0&id=479b05bd&scoped=true&lang=scss&"
import style1 from "./ObjectsMap.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479b05bd",
  null
  
)

export default component.exports